import { createAction, props } from '@ngrx/store';
import { BinLocationsListState } from '../reducers';
import { BinLocationsTabsEnum } from '../../enums';

export const LoadBinLocationsList = createAction(
  '[Bin locations] Load Bin locations List',
  props<{ binLocationsListData: BinLocationsListState, location: BinLocationsTabsEnum }>()
);
